import React from 'react';
import './styles.scss';

const BundleLabel = ({ ticketsCount }) => {
  // if (ticketsCount === 10) {
  //   return (
  //     <div className="single-bundle-card__ticket-label single-bundle-card__ticket-label--red">
  //       MOST POPULAR
  //     </div>
  //   );
  // } else
     if (ticketsCount >= 15) {
    return (
      <div className="single-bundle-card__ticket-label">
        BEST VALUE BUNDLE
      </div>
    );
  }
  return null;
};

export default BundleLabel;
